import Vue from 'vue'
import router from '@/router'
import * as Sentry from '@sentry/vue'

export const installSentry = () => {
  Sentry.init({
    Vue,
    dsn: 'https://3a937188d3e024742bd83acb9786d900@sentry.dev.teamnoteapp.com/2',
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/booking-apptask.teamnoteapp\.com\/api/, /^\//],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        trackComponents: true,
        hooks: ['mount', 'update', 'destroy']
      }),
      new Sentry.Replay()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
